<button
    #languageTrigger
    id="header-lang-trigger"
    type="button"
    class="m-0 inline-flex h-10 cursor-pointer flex-row items-center justify-center gap-1 rounded-full border-0 bg-transparent p-2 hover:bg-[var(--bgColorTertiary)]"
    [attr.aria-label]="'header.alt-texts.language-selection' | translate"
    aria-controls="header-lang-options"
    aria-haspopup="listbox"
    [attr.aria-expanded]="languageMenuOpen()"
    (click)="toggleLanguageMenu($event)"
    (keydown)="handleTriggerKeydown($event)"
>
    <sh-icon class="text-[24px] leading-none text-[rgb(var(--ui-5))]" icon="globe" size="s" aria-hidden="true" />
    <span class="w-[15px] text-[12px] leading-4 text-[var(--color-text-active)]">{{
        selectedLang().toUpperCase()
    }}</span>
</button>
<sh-popover
    target="header-lang-trigger"
    position="bottom-left"
    class="z-[200] p-0 rounded-none"
    [manualControlled]="true"
    [visible]="languageMenuOpen()"
    (overlayClosed)="languageMenuOpen.set(false)"
>
    <sh-list
        id="header-lang-options"
        flat
        role="listbox"
        [attr.aria-label]="'header.alt-texts.language-selection' | translate"
    >
        @for (option of languageOptions; track option.code; let index = $index) {
            <sh-list-item
                #languageOption
                divider="none"
                clickable
                role="option"
                iconColor="primary"
                [label]="option.labelKey | translate"
                [icon]="selectedLang() === option.code ? 'checkmark' : ' '"
                [active]="selectedLang() === option.code"
                [attr.aria-label]="getLanguageAriaLabel(option) | translate"
                [attr.aria-selected]="selectedLang() === option.code"
                [attr.tabindex]="languageMenuOpen() ? '0' : '-1'"
                (click)="changeLang(option.code)"
                (keydown)="handleOptionKeydown($event, index)"
            />
        }
    </sh-list>
</sh-popover>
